export default __webpack_public_path__ + "static/media/icon_grant.9948c2ee.svg";